<template>
  <a-form ref="formRef"
          :model="formState"
          name="basic"
          :label-col="{ span: 7, style: { width: '100px' } }"
          :wrapper-col="{ span: 12 }"
          autocomplete="off"
          @finish="onFinish"
          @finishFailed="onFinishFailed">
    <a-form-item label="姓名"
                 name="fullname"
                 :rules="[{ required: true, validator: formValidate.username }]">
      <a-input v-model:value="formState.fullname" />
    </a-form-item>

    <a-form-item label="个人照片"
                 name="photo">
      <avatar @avatar='getFile'
              class='avatar-viewer'
              :width='100'
              :height='100'
              :radius='50'
              title="上传个人头像"
              previewHint="图像预览"
              cropHint="最佳尺寸 100×100，可以上传高质量图片进行裁切"
              selectImgHint="选择图片"
              okText="确认"
              cancelText="取消">
        <template #controller>
          <avatar-viewer :img='gravatar'
                         :width='100'
                         :height='100'
                         :radius='50'
                         showUpload />
        </template>
      </avatar>
    </a-form-item>

    <a-form-item label="入职时间"
                 name="joinTime"
                 :rules="[{ required: true, validator: formValidate.joinTime }]">
      <a-date-picker v-model:value="formState.joinTime"
                     value-format="YYYY-MM-DD" />
    </a-form-item>

    <a-form-item label="性别"
                 name="sex">
      <a-radio-group v-model:value="formState.sex"
                     name="radioGroup">
        <a-radio value="male">男</a-radio>
        <a-radio value="female">女</a-radio>
      </a-radio-group>
    </a-form-item>

    <a-form-item label="出生日期"
                 name="birthday"
                 :rules="[{ required: true, validator: formValidate.birthday }]">
      <a-date-picker v-model:value="formState.birthday"
                     value-format="YYYY-MM-DD" />
    </a-form-item>

    <a-form-item label="学历"
                 name="educationString">
      <a-select v-model:value="formState.education">
        <a-select-option v-for="(item, index) in education"
                         :key="index"
                         :value="item.value">{{ item.title }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <a-form-item label="政治面貌"
                 name="politic">
      <a-select v-model:value="formState.politic">
        <a-select-option v-for="(item, index) in politicalStatus"
                         :key="index"
                         :value="item.value">{{
                         item.title
                         }}
        </a-select-option>
      </a-select>
    </a-form-item>

    <!-- <a-form-item label="加入时间"
                 name="joinTime">
      <a-date-picker v-model:value="formState.joinTime"
                     value-format="YYYY-MM-DD" />
    </a-form-item> -->

    <a-form-item label="电话"
                 name="telPhone">
      <a-input v-model:value="formState.telephone" />
    </a-form-item>

    <a-form-item :wrapper-col="{ offset: 7, span: 16 }">
      <a-button type="primary"
                html-type="submit">保存</a-button>
    </a-form-item>
  </a-form>
</template>

<script setup lang="ts">
import { CORE_AXIOS, type Http } from '@/core'
import { toUrl } from '@/utils'
import { Avatar, AvatarViewer } from '@iota-cn/ui-components'
import { Validator } from '@iota-cn/util-validation'
import { message } from 'ant-design-vue'
import type { Rule } from 'ant-design-vue/lib/form'
import { container } from 'tsyringe'
import { computed, reactive, ref, watch } from 'vue'
import { useRbacStore } from '../../DefaultRbacPagePlugin'


interface FormState {
  userId: string
  entryDate: string
  createdAt: string
  updatedAt: string
  fullname: string
  sex: string
  birthday: string
  education?: string
  politic?: string
  entryTime: string
  joinTime: string
  telephone?: number
  photo?: string
}

const rbac = useRbacStore()
const axios = container.resolve<Http>(CORE_AXIOS)
const formRef = ref()
const visible = ref<boolean>(false)
const confirmLoading = ref<boolean>(false)
//@todo 从字典接口获取
const education = reactive<{ title: string, value: number }[]>([
  { title: '大专', value: 0 },
  { title: '本科', value: 1 },
  { title: '硕士', value: 2 },
  { title: '博士', value: 3 },
  { title: '其他', value: 4 },
  { title: '初中', value: 5 },
  { title: '高中', value: 6 },
  { title: '技校', value: 7 },
  { title: '小学', value: 8 },
  { title: '党校', value: 9 },
  { title: '大学', value: 10 },
  { title: '中专', value: 11 }
])
//@todo 从字典接口获取
const politicalStatus = reactive<{ title: string, value: number }[]>([
  { title: '中共党员', value: 0 },
  { title: '中共预备党员', value: 1 },
  { title: '共青团员', value: 2 },
  { title: '中共党员', value: 0 },
])
const formState = reactive<Partial<FormState>>({
  userId: '',
  entryDate: '',
  sex: 'male',
  birthday: '',
  joinTime: '',
})

watch(
  () => rbac.$state.models.user, () => {
    getDataSource()
  }
)

//根据用户管理选择的数据行 详细信息回显
const getDataSource = () => {
  const { id } = rbac.models.user[0]
  axios.get('/v1/api/authorizations/users/' + id + '/extention').then(result => {
    const resultData = result as FormState
    if (Object.keys(resultData).length > 0) {
      Object.assign(formState, resultData)
    } else {
      Object.assign(formState, {
        userId: '',
        fullname: '',
        telephone: '',
        entryDate: '',
        education: '',
        politic: '',
        sex: 'male',
        photo: '',
        birthday: '',
        joinTime: '',
      })
    }
  })
}

const onFinish = () => {
  const { id } = rbac.models.user[0]
  formRef.value.validate().then(() => {
    confirmLoading.value = true
    axios.put("/v1/api/authorizations/users/" + id + '/extention', formState).then(() => {
      visible.value = false
      confirmLoading.value = false
      message.success('修改成功')
    })
  })
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const onFinishFailed = (errorInfo: any) => {
  console.log('Failed:', errorInfo)
}

const gravatar = computed(() => {
  const user = rbac.models?.user[0]
  return toUrl(formState.photo || user?.gravatar || '')
})

const getFile = (canvas: HTMLCanvasElement) => {
  canvas.toBlob((blob: Blob | null) => {
    if (blob) {
      const user = rbac.models.user[0]
      const fd = new FormData()
      fd.append("fileBlob", blob, `${user.username}.png`) //目前后端做的验证必须加后缀
      axios.post('/v1/api/attachment/gravatar', fd)
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then((res: any) => {
          formState.photo = res.uploaded
        }).catch(() => {
          return
        })
    }
  })
}

// 表单校验规则
const formValidate = {
  /** 是否填写出生日期 */
  birthday: (_rule: Rule, value: string): Promise<string | void> => {
    if (!value) {
      return Promise.reject('请选择出生日期')
    } else {
      return Promise.resolve()
    }
  },
  /** 用户是否重复 */
  username: (_rule: Rule, value: string): Promise<string | void> => {
    if (!value) {
      return Promise.reject('用户名不允许为空')
    }
    else if (value.length <= 1) {
      return Promise.reject('用户名不允许长度小于1')
    } else {
      return axios.get(`/v1/api/validations/usernames/validate?username=${value}`).then(() => {
        return Promise.resolve()
      }).catch(() => {
        return Promise.reject('用户名已重复')
      })
    }
  },
  /** 入职时间 */
  joinTime: (_rule: Rule, value: string): Promise<string | void> => {
    if (value.length <= 1) {
      return Promise.reject('请选择入职日期')
    } else {
      return Promise.resolve()
    }
  }
}
</script>

<style lang="less" scoped>
.formMain {
  .personPic {
    width: 300px;
  }
}
</style>
